import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import { NgxCurrencyConfig, NgxCurrencyInputMode } from 'ngx-currency';

@Component({
    selector: 'app-question-min-max-textbox',
    templateUrl: './question-min-max-textbox.component.html',
    styleUrls: ['./question-min-max-textbox.component.scss'],
    standalone: false
})
export class QuestionMinMaxTextboxComponent implements OnInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Output() questionAnswer = new EventEmitter();
  @Output() hasError = new EventEmitter<boolean>();

  value = 0;

  uniqueControlName = `min-max-textbox-control-${newGuid()}`;
  uniqueId = `min-max-textbox-id-${newGuid()}`;
  parameters: any[] = [];
  maskOptions: NgxCurrencyConfig;  
  showError = false;
  currency: string;
  constructor(public questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    if (this.question) {
      
      if (this.question?.answer) {
        this.value = +this.question.answer;
      }
      else if (this.question?.recommended) {
        this.value = +this.question?.recommended;
      }
      else {
        this.value = +this.question?.min_val;
      }


      if (this.question?.parameter) {
        this.parameters = JSON.parse(this.question?.parameter);
      }

      if (this.parameters?.length) {
          this.currency = this.parameters?.find(x => x?.parameter === 'currency')?.value;
      }

      if (this.question?.answer) {
        this.value = +this.question?.answer;
      }
    }

    this.maskOptions = {
      max: this.question?.max_val ? this.question?.max_val : null,
      allowZero: true,
      nullable: true,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: '',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };

    this.onChange();
  }
  onChange(): void {
   
    if (this.question && (this.value || this.value === 0) && this.value !== +this.question?.answer) {
      this.question.answer = this.value.toString();
      this.questionAnswer.emit(this.question);
    }
  }
  validateInput(): void {
    if (+this.value > +this.question?.max_val || +this.value < +this.question?.min_val){
      this.showError = true;
      this.hasError.emit(true);
    }
    else {
      this.showError = false;
      this.hasError.emit(false);
      this.question.answer = this.value.toString();
      this.questionAnswer.emit(this.question);
    }
  }

}
